export enum DayPhase {
  MORNING = 'morning',
  BEACH = 'beach',
  BAR = 'bar'
}

export enum BeachPhase {
  CHECK_CONDITIONS = 'check_conditions',
  DECIDE_BEACH = 'decide_beach',
  SURF = 'surf'
}

export enum WaveSize {
  FLAT = 'flat',
  SMALL = 'small',
  MEDIUM = 'medium',
  GOOD = 'good',
  BIG = 'big',
  HUGE = 'huge'
}

export enum WindCondition {
  OFFSHORE = 'offshore',    // Best
  LIGHT = 'light',          // Good
  CROSS = 'cross-shore',    // OK
  ONSHORE = 'onshore'       // Bad
}

export interface WaveConditions {
  size: WaveSize;
  gnarliness: number;  // 1-10 scale
  wind: WindCondition;
  description: string;
}

export interface GameState {
  day: number;
  money: number;
  groupMorale: number;
  hangoverLevel: number;
  energy: number;
  surfsSoFar: number;
  partyCount: number;
  dayPhase: DayPhase;
  beachPhase: BeachPhase | null;
  timeOfDay: number; // 0-24, tracks time progression especially at bar
  wentToLagosToday: boolean;
  surfedToday: boolean;
  wentToBarToday: boolean; // Track if bar was visited today
  currentConditions: WaveConditions | null;
  consecutiveHighHangoverDays: number; // Track days with hangover >= 80
  daysWithLowMorale: number; // Track days ended with morale < 40
  hasGoneToLagos: boolean; // Track if Lagos trip happened at all during the trip
  eventsTriggeredToday: string[]; // Track which events have been triggered today
  lastBreakfastDay: number; // Track last day someone made breakfast
}

export interface GroupMember {
  id: string;
  name: string;
  energy: number;
  hangover: number;
  injured: boolean;
  drinkingUrge: number;
}

export interface GameEvent {
  id: string;
  title: string;
  description: string;
  choices: EventChoice[];
  image?: string;
  allowedPhases: DayPhase[]; // Which phases this event can occur in
}

export interface EventChoice {
  text: string;
  effects: StateEffects;
}

export interface StateEffects {
  money?: number;
  groupMorale?: number;
  hangoverLevel?: number;
  energy?: number;
  surfsSoFar?: number;
  partyCount?: number;
  timeOfDay?: number;
}

export enum GameScene {
  MENU = 'menu',
  INSTRUCTIONS = 'instructions',
  VILLA = 'villa',
  BEACH = 'beach',
  BAR = 'bar',
  EVENT = 'event',
  DAY_SUMMARY = 'day_summary'
}
